<script setup lang="ts">
import vReveal from "@/application/directives/vReveal";

const steps = [
  {
    title: "Taken inrichten",
    text: "Maak categorieën en taken aan voor het seizoen - met datum, tijd en aantal benodigde vrijwilligers.",
  },
  {
    title: "Leden melden zich aan",
    text: "Leden melden zich zelf aan voor een taak, of het bestuur deelt ze rechtstreeks in.",
  },
  {
    title: "Automatisch bericht",
    text: "Klupz stuurt direct een bevestiging - zonder dat iemand het hoeft te sturen.",
  },
  {
    title: "Overzicht na afloop",
    text: "Per lid en periode zie je precies hoeveel uur iemand heeft gedraaid, en wie is vrijgesteld of heeft afgekocht.",
  },
];
</script>

<template>
  <section id="hoe-het-werkt" class="steps">
    <VContainer class="landing-container">
      <div v-reveal>
        <p class="landing-eyebrow">Zo werkt het</p>
        <h2 class="landing-h2">
          Van seizoensplanning tot afgeronde taak, in vier stappen.
        </h2>
      </div>

      <VRow v-reveal class="mt-4">
        <VCol
          v-for="(step, index) in steps"
          :key="step.title"
          cols="12"
          sm="6"
          lg="3"
        >
          <span class="steps__index">{{
            String(index + 1).padStart(2, "0")
          }}</span>
          <h3 class="landing-h3 mt-3 mb-2">{{ step.title }}</h3>
          <p class="steps__text">{{ step.text }}</p>
        </VCol>
      </VRow>
    </VContainer>
  </section>
</template>

<style scoped lang="scss">
.steps {
  padding: 48px 0;
}

.steps__index {
  display: inline-block;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.04em;
  color: rgb(var(--v-theme-accent));
  background: rgb(var(--v-theme-stepper-surface));
  border-radius: 999px;
  padding: 5px 11px;
}

.steps__text {
  font-size: 14.5px;
  color: rgb(var(--v-theme-emphasis));
  line-height: 1.6;
}
</style>
